<template>
  <div v-if="loggedIn" class="col-12 py-4 text-center footer-div d-flex justify-content-end align-items-center colour-foot-bg" :style="layoutColours || {}" :class="{ customLayout: (layout == 'custom')}">
    <span class="mr-2 footer-text">{{ t('supportedBrowsersText', 'supportedBrowsersText') }}</span>
    <span>
      <a href="https://www.mozilla.org/en-GB/firefox/new/" target="_blank">
        <fontAwesomeIcon :icon="['fab', 'firefox']" size="2x" class="mr-2"/>
      </a>
      <a href="https://www.google.com/intl/en_uk/chrome/" target="_blank">
        <fontAwesomeIcon :icon="['fab', 'chrome']" size="2x" class="mr-2"/>
      </a>
      <a href="https://www.opera.com/en/download" target="_blank">
        <fontAwesomeIcon :icon="['fab', 'opera']" size="2x" class="mr-2"/>
      </a>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "Footer",
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['getLayout', 'getLayoutColours', 'loggedIn', 'templateDetails', 'getUserLevel']),
    layout: {
        get() {
            return this.$store.getters.getLayout.layout
        }
    },
    colours: {
        get() {
            return this.$store.getters.getLayoutColours
        }
    },
    layoutColours() {
      var layout = this.layout

      if(layout == 'custom'){
        if(Object.keys(this.colours).length){
          // we should get the colours from the vuex state when we log in
          return {
            '--colour-foot-bg': this.colours.colour_nav_bg
          }
        } else {
          var appearanceColours = JSON.parse(localStorage.getItem('appearanceColours'))
          if(appearanceColours){
            // In case we can't get the colours from the vuex state, we try to fetch them from local storage
            return {
              '--colour-foot-bg': appearanceColours.colour_nav_bg
            }
          } else {
            return {}
          }
        }
      }
    },
  }
}

</script>


<style>

.colour-foot-bg {
  /*background-color: var(--colour-foot-bg) !important;*/
}

.footer-div {
  position: absolute;
  bottom: -50px;
  max-height: 60px !important;
  min-height: 30px !important;
  color: #334152 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}



.footer-text {
  font-size: 16px;
  font-weight: 600;
}

</style>
